import { IJsonQuery } from '../../types/jsonQuery';

export const getPrice = ({ price }: IJsonQuery) => {
  const gte = price && price.value ? price.value.gte : '';
  const lte = price && price.value ? price.value.lte : '';

  return { gte, lte };
};
